const MODAL_ACTIVE_CLASS = "is-active";
const BODY_LOCK_CLASS = "is-modal-open";

// モーダル開閉時の共通UI状態（表示状態とbodyスクロール固定）を切り替える
function setModalState(modalEl: HTMLElement, isOpen: boolean) {
  modalEl.classList.toggle(MODAL_ACTIVE_CLASS, isOpen);
  modalEl.setAttribute("aria-hidden", String(!isOpen));
  document.body.classList.toggle(BODY_LOCK_CLASS, isOpen);
}

// ドロワーモーダルのイベントをまとめてセットアップ
export function initModal(): void {
  const modalEl = document.querySelector<HTMLElement>(".js-modal");
  if (!modalEl) return;

  const openButtons = Array.from(
    document.querySelectorAll<HTMLElement>(".js-modal-open"),
  );
  const closeButtons = Array.from(
    modalEl.querySelectorAll<HTMLElement>(".js-modal-close"),
  );

  const open = () => setModalState(modalEl, true);
  const close = () => setModalState(modalEl, false);

  // ヘッダーボタンから開く
  openButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      open();
    });
  });

  // オーバーレイ/閉じるボタンから閉じる
  closeButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      close();
    });
    // closeアイコンをキーボードでも閉じられるように
    btn.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        close();
      }
    });
  });

  // .sub-menu 内のページ内リンクをクリックしたら閉じる
  const anchorLinks = Array.from(
    modalEl.querySelectorAll<HTMLAnchorElement>(".sub-menu a[href*='#']"),
  );
  anchorLinks.forEach((link) => {
    link.addEventListener("click", () => close());
  });

  // Escapeキーで閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (!modalEl.classList.contains(MODAL_ACTIVE_CLASS)) return;
    close();
  });
}
